import React from "react"
import { BsPrinter } from "react-icons/bs"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { IconButton, } from "components"
import classes from "./OrderDetailsPrintButton.module.scss"

const OrderDetailsPrintButton = props => {
  const { order } = props

  const [t, i18n] = useTranslation()

  const handlePrintOrder = async () => {
    sessionStorage.setItem(
      "data",
      JSON.stringify({
        type: "order",
        value: [order]
      })
    )

    window.open("/print", "_blank")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={classes["container"]}
      onClick={handlePrintOrder}
    >
      <IconButton
        icon={BsPrinter}
        size={18}
        loadingColor="black"
      />
      <span
        className={clsx(
          classes["text"],
          isLtr && classes["text-ltr"]
        )}
      >
        {t("پرینت_رسید_مشتری")}
      </span>
    </div>
  )
}

export default OrderDetailsPrintButton